<sh-box id="chatbot-box-1" [background]="size === 'large' ? 'surface-secondary' : 'surface'" layout="vertical" elevation="none"
  style="height: 100%" [padding]="pipMode ? 'none' : 'compact'">

  @if (screenInfo$ | async; as screen ) {
    <sh-box-section id="chatbot-box-section-2" style="height: 100%">
      <!-- !Initial View -->
      @if (initialViewActive) {
        <div [ngClass]="pipMode ? 'initial-view pip' : 'initial-view'"
          >
          @if (!pipMode) {
            <sh-text id="chatbot-text-3" [ngClass]="'display-500'" style="text-align: center;">{{ 'chatbot.greeting' | transloco: { name: userData.basic["givenName"] } }}</sh-text>
          }
          <!-- Search Bar -->
          @if (!pipMode) {
            <app-chat-search #searchbar
              [disabled]="isStreaming || (displayedMessages && displayedMessages[displayedMessages.length - 1]?.options?.length > 0)"
              (search)="sendMessage($event, 'chat', undefined, undefined, shouldMarkPromptAsOptionAnswer() ? true : undefined)" [label]="'chatbot.search.placeholder' | transloco"
              [style.width]="defineChatSize(screen.size,'initial')">
              <sh-icon #aiicon size="xs" (click)="openAI()" id="ai-tip" icon="panel" button></sh-icon>
            </app-chat-search>
          }
          @if (visibleDevicePrompts.length > 0 && !isPromptsLoading && selectedType === 'device' && pipMode) {
            <div [@fadeSwitch]="isPromptsLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              @for (prompt of visibleDevicePrompts; track prompt.short_prompt + '-' + prompt.prompt) {
                <sh-button id="chatbot-button-ai-generative" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'"
                  style="max-width: 100%;" [label]="prompt.short_prompt"
                  layout="classic" color="tertiary" size="auto"
                (click)="sendMessage($event, 'pre', prompt.prompt)"></sh-button>
              }
            </div>
          }
          <!-- Site Pre-Prompts -->
          @if (visibleSitePrompts.length > 0 && !isPromptsSiteLoading && selectedType === 'site' && pipMode) {
            <div [@fadeSwitch]="isPromptsSiteLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              @for (prompt of visibleSitePrompts; track prompt.short_prompt + '-' + prompt.prompt; let i = $index) {
                <sh-button id="chatbot-button-ai-generative-{{i}}" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'"
                  style="max-width: 100%;" [label]="prompt.short_prompt"
                  layout="classic" color="tertiary" size="auto"
                (click)="sendMessage($event, 'pre', prompt.prompt)"></sh-button>
              }
              @for (prompt of visibleSitePrompts; track prompt.short_prompt + '-' + prompt.prompt; let i = $index) {
                <sh-tooltip id="chatbot-tooltip-ai-generative-{{i}}" target="chatbot-button-ai-generative-{{i}}" [label]="prompt.short_prompt"></sh-tooltip>
              }
            </div>
          }
          @if (bpCanMachineData && selectedType === 'device' && ((!isPromptsLoading && visibleDevicePrompts.length === 0 && device && pipMode) || isPromptsError)) {
            <div
              [@fadeSwitch]="isPromptsLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-no-recommendations-availa" disabled icon-position="left" icon="ai-generative" class="magic-button disabled"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.noRecommendations' | transloco" layout="classic" color="tertiary"
              size="auto"></sh-button>
            </div>
          }
          @if (selectedType === 'site' && ((!isPromptsSiteLoading && visibleSitePrompts.length === 0 && device && pipMode) || isPromptsSiteError)) {
            <div
              [@fadeSwitch]="isPromptsSiteLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-no-recommendations-availa" disabled icon-position="left" icon="ai-generative" class="magic-button disabled"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.noRecommendations' | transloco" layout="classic" color="tertiary"
              size="auto"></sh-button>
            </div>
          }
          @if (pipMode) {
            <div style="display: flex; align-items: center; justify-content: space-between;gap: 8px; width: 100%;">
              <sh-icon #aiiconPip style="margin: 0 4px" size="xs" (click)="openAIPip()" id="ai-tip-pip" icon="panel" button></sh-icon>
              <app-chat-search [pipMode]="true" #searchbar style="width: calc(100% - 32px);"
                [disabled]="isStreaming || (displayedMessages && displayedMessages[displayedMessages.length - 1]?.options?.length > 0)"
                (search)="sendMessage($event, 'chat', undefined, undefined, shouldMarkPromptAsOptionAnswer() ? true : undefined)" [label]="'chatbot.search.placeholder' | transloco"
                >
              </app-chat-search>
            </div>
          }
          <!-- Device Pre-Prompts -->
          @if (visibleDevicePrompts.length > 0 && !isPromptsLoading && selectedType === 'device' && !pipMode) {
            <div [@fadeSwitch]="isPromptsLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              @for (prompt of visibleDevicePrompts; track prompt.short_prompt + '-' + prompt.prompt) {
                <sh-button id="chatbot-button-ai-generative" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'"
                  style="max-width: 100%;" [label]="prompt.short_prompt"
                  layout="classic" color="tertiary" size="auto"
                (click)="sendMessage($event, 'pre', prompt.prompt)"></sh-button>
              }
            </div>
          }
          <!-- Site Pre-Prompts -->
          @if (visibleSitePrompts.length > 0 && !isPromptsSiteLoading && selectedType === 'site' && !pipMode) {
            <div [@fadeSwitch]="isPromptsSiteLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              @for (prompt of visibleSitePrompts; track prompt.short_prompt + '-' + prompt.prompt) {
                <sh-button id="chatbot-button-ai-generative" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'"
                  style="max-width: 100%;" [label]="prompt.short_prompt"
                  layout="classic" color="tertiary" size="auto"
                (click)="sendMessage($event, 'pre', prompt.prompt)"></sh-button>
              }
            </div>
          }
          <!-- Loading States for Prompts -->
          @if (bpCanMachineData && isPromptsLoading && selectedType === 'device') {
            <div [@fadeSwitch]="isPromptsLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-generating-troubleshootin" icon-position="left" icon="ai-generative" class="magic-button loading"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.generating' | transloco" layout="classic"
              color="tertiary" size="auto"></sh-button>
            </div>
          }
          @if (isPromptsSiteLoading && selectedType === 'site') {
            <div [@fadeSwitch]="isPromptsSiteLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-generating-troubleshootin" icon-position="left" icon="ai-generative" class="magic-button loading"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.generating' | transloco" layout="classic"
              color="tertiary" size="auto"></sh-button>
            </div>
          }
          <!-- Disabled States for Prompts -->
          @if (bpCanMachineData && selectedType === 'device' && ((!isPromptsLoading && visibleDevicePrompts.length === 0 && device && !pipMode) || isPromptsError)) {
            <div
              [@fadeSwitch]="isPromptsLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-no-recommendations-availa" disabled icon-position="left" icon="ai-generative" class="magic-button disabled"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.noRecommendations' | transloco" layout="classic" color="tertiary"
              size="auto"></sh-button>
            </div>
          }
          @if (selectedType === 'site' && ((!isPromptsSiteLoading && visibleSitePrompts.length === 0 && device && !pipMode) || isPromptsSiteError)) {
            <div
              [@fadeSwitch]="isPromptsSiteLoading ? 'loading' : 'loaded'"
              style="width: 90%; display: flex; flex-wrap: wrap; gap: 9px; justify-content: center;">
              <sh-button id="chatbot-button-no-recommendations-availa" disabled icon-position="left" icon="ai-generative" class="magic-button disabled"
                style="max-width: 100%;" [attr.label]="'chatbot.prompts.noRecommendations' | transloco" layout="classic" color="tertiary"
              size="auto"></sh-button>
            </div>
          }
          @if (!pipMode) {
            <sh-tag id="chatbot-tag-which-products-are-suppor"  [attr.label]="'chatbot.supportedProducts' | transloco"
            (click)="document.querySelector('#info-modal')['visible'] = true"></sh-tag>
          }
        </div>
      }
      <!-- !Chat View padding-bottom: 80px; margin-bottom: 80px-->
      @if (!initialViewActive) {
        <div #chats
          style="height: 100%; width: 100%; display: flex; flex-direction: column; gap: 24px; overflow: auto; margin-bottom: 16px;">
          @for (message of displayedMessages; track (message.uuid || (message.chatId + '-' + message.number)); let i = $index) {
            <div
              style="width: 100%; height: auto; display: flex; gap: 12px">
              <!-- User Question -->
              @if (message.from==='user') {
                <div
                  style="width: 100%; height: auto; display: flex; gap: 16px; flex-direction: row-reverse;  padding-right: 12px">
                  @if (userData['photo'] !== null && !pipMode) {
                    <sh-user-identifier id="chatbot-user-identifier-12"
                      style="scale: transform; pointer-events: none;"
                    image="url({{userData['photo']}})"></sh-user-identifier>
                  }
                  @if (userData['photo'] === null && !pipMode) {
                    <sh-user-identifier id="chatbot-user-identifier-13"
                    [initials]='userData["basic"]["givenName"].substring(0,1) + userData["basic"]["surname"].substring(0,1)'></sh-user-identifier>
                  }
                  <sh-box id="user-{{i}}" [background]="size === 'large' ? 'surface-tertiary' : 'surface-secondary'" divider="none"
                    padding="compact" style="max-width: 50%;  padding-top: 0px; padding-bottom: 0px;">
                    <sh-box-section id="user-time-{{i}}" style="padding-top: 12px; padding-bottom: 2px;">
                      <sh-text id="chatbot-text-14" ngClass="body-100 color-disabled">{{formatTimestamp(message.timestamp)}}</sh-text>
                    </sh-box-section>
                    <sh-box-section id="user-text-{{i}}" style="padding-top: 2px;">
                      <sh-text id="chatbot-text-15" size="body-1">{{message.text}}</sh-text>
                    </sh-box-section>
                  </sh-box>
                </div>
              }
              <!-- Bot Reply -->
              @if ((message.from==='bot' || message.from === 'bot-like') && message.type==='text') {
                <div
                  style="width: 100%; height: auto;">
                  <!-- Reply Bubble -->
                  <div style="width: 100%; height: auto; display: flex; gap: 16px;">
                    @if (!pipMode) {
                      <sh-user-identifier id="chatbot-user-identifier-16" initials="AX"
                      style="scale: transform; pointer-events: none;"></sh-user-identifier>
                    }
                    <sh-box id="bot-{{i-1}}" [background]="size === 'large' || pipMode ? 'surface-tertiary' : 'surface-secondary'"
                      padding="compact" style="max-width: 70%; padding-top: 0px; padding-bottom: 0px;">
                      @if (message.iStreaming || message.text.length > 0 || message.interruptedByUser) {
                        <sh-box-section
                          id="bot-time-{{i-1}}" style="padding-top: 12px; padding-bottom: 2px;">
                          <sh-text id="chatbot-text-17" ngClass="body-100 color-disabled">{{formatTimestamp(message.timestamp)}}</sh-text>
                        </sh-box-section>
                      }
                      <sh-box-section id="bot-text-{{i-1}}" class="bot-text-section" [ngClass]="pipMode ? 'pip' : ''" (click)="onChatContentClick($event)"
                        [class.bot-text-section--standalone]="message.iStreaming && !message.text && !message.interruptedByUser"
                        #chatmessage>
                        @if (message.iStreaming || message.reasoningTrace?.length || message.reasoningSteps?.length) {
                          <div
                            class="reasoning-block"
                            [class.reasoning-block--standalone]="message.iStreaming && !message.text">
                            @if (message.iStreaming) {
                              <div
                                class="reasoning-summary-row reasoning-summary-row--live"
                                [class.reasoning-summary-row--interactive]="hasVisibleReasoningDetails(message)"
                                (click)="toggleReasoningTrace(message)">
                                <div class="thinking-loader-wrap" aria-hidden="true">
                                  <div class="thinking-loader"></div>
                                </div>
                                <div class="reasoning-label-area">
                                  <sh-text id="chatbot-text-18" size="body-1" color="secondary"
                                    class="reasoning-meta-text reasoning-meta-text--live">
                                    {{getLiveReasoningLabel(message)}}
                                  </sh-text>
                                  @if (hasVisibleReasoningDetails(message)) {
                                    <sh-icon id="chatbot-icon-19" button size="xs" class="reasoning-toggle-icon"
                                    [icon]="isReasoningTraceExpanded(message) ? 'arrow-line-up-s' : 'arrow-line-down-s'"></sh-icon>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="reasoning-summary-row reasoning-summary-row--static"
                                [class.reasoning-summary-row--interactive]="hasVisibleReasoningDetails(message)"
                                (click)="toggleReasoningTrace(message)">
                                <sh-text id="chatbot-text-22" size="body-1" color="secondary"
                                  class="reasoning-meta-text">
                                  {{message.thoughtDurationLabel}}
                                </sh-text>
                                @if (hasVisibleReasoningDetails(message)) {
                                  <sh-icon id="chatbot-icon-23" button size="xs" class="reasoning-toggle-icon"
                                  [icon]="isReasoningTraceExpanded(message) ? 'arrow-line-up-s' : 'arrow-line-down-s'"></sh-icon>
                                }
                              </div>
                              @if (hasVisibleReasoningDetails(message) && isReasoningTraceExpanded(message)) {
                                <div class="reasoning-trace">
                                  @for (reasoningStep of getVisibleReasoningSteps(message); track (reasoningStep.category + '-' + (reasoningStep.result || '') + '-' + $index)) {
                                    <div class="reasoning-step">
                                      @if (reasoningStep.category) {
                                        <sh-text id="chatbot-text-24" size="body-2" color="secondary"
                                        class="reasoning-step-category">{{reasoningStep.category}}</sh-text>
                                      }
                                      @for (reasoningLine of getReasoningResultLines(reasoningStep); track reasoningLine) {
                                        <sh-text id="chatbot-text-25"
                                          size="body-1" color="secondary"
                                        class="reasoning-trace-line">{{reasoningLine}}</sh-text>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            }
                            @if (message.iStreaming && hasVisibleReasoningDetails(message) && isReasoningTraceExpanded(message)) {
                              <div class="reasoning-trace">
                                @for (reasoningStep of getVisibleReasoningSteps(message); track (reasoningStep.category + '-' + (reasoningStep.result || '') + '-' + $index)) {
                                  <div class="reasoning-step">
                                    @if (reasoningStep.category) {
                                      <sh-text id="chatbot-text-20" size="body-2" color="secondary"
                                      class="reasoning-step-category">{{reasoningStep.category}}</sh-text>
                                    }
                                    @for (reasoningLine of getReasoningResultLines(reasoningStep); track reasoningLine) {
                                      <sh-text id="chatbot-text-21"
                                        size="body-1" color="secondary"
                                      class="reasoning-trace-line">{{reasoningLine}}</sh-text>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                        <!-- Chat Bot Text -->
                        <sh-text id="chatbot-text-26" [innerHTML]="message.text | markdown" size="body-1"></sh-text>
                        @if (message.interruptedByUser) {
                          <sh-text id="chatbot-text-27" size="body-1" style="font-weight: bold;">{{ message.interruptedLabel }}</sh-text>
                        }
                        <!-- Normal Options for Bot -->
                        @if (message.options?.length > 0 && (message.from === 'bot' || message.from === 'bot-like')) {
                          <div
                            style="display: flex; gap: 8px; flex-wrap: wrap;">
                            @for (option of message.options; track option) {
                              <sh-button id="chatbot-button-28" color="tertiary" [label]='option'
                                [disabled]="displayedMessages[i + 1]?.isOptionAnswer" size="max-content"
                              (click)="sendMessage($event, 'option', option, message.from === 'bot-like' ? option : undefined, true)"></sh-button>
                            }
                          </div>
                        }
                        <!-- AI Safety Hint-->
                        @if (message.final_answer) {
                          <div style="display: flex; flex-direction: column; gap: 8px; align-items: flex-end;"
                            >
                            <sh-text id="chatbot-text-29" [innerHTML]="message.message_info | markdown"></sh-text>
                          </div>
                        }
                        <!-- Feedback Section -->
                        @if (message.final_answer) {
                          <div style="display: flex; flex-direction: column; gap: 8px; align-items: flex-end;"
                            >
                            <div style="display: flex; gap: 8px">
                              <sh-button id="chatbot-button-like" class="feedback-button" [attr.label]="'chatbot.feedback.like' | transloco" icon="like" layout="compact"
                                [color]="message.feedbackType==='like' ? 'secondary' : 'tertiary'"
                                [disabled]="message.feedbackLocked" (click)="handleFeedback(message, 'like')"
                              shape="pill-s"></sh-button>
                              <sh-button id="chatbot-button-dislike" class="feedback-button" [attr.label]="'chatbot.feedback.dislike' | transloco" icon="dislike"
                                layout="compact"
                                [color]="message.feedbackType==='dislike' ? 'secondary' : 'tertiary'"
                                [disabled]="message.feedbackLocked"
                              (click)="handleFeedback(message,'dislike')" shape="pill-s"></sh-button>
                            </div>
                            @if (message.feedbackType && !message.feedbackSubmitted && message.feedbackType==='dislike') {
                              <sh-input-text id="chatbot-input-text-feedback"
                                [attr.label]="'chatbot.feedback.label' | transloco" type="text" textarea rows="2"
                                [attr.mandatory]="message.isMandatory ? '' : null"
                                [attr.hint]="message.isMandatory ? ('chatbot.feedback.hintMandatory' | transloco) : ('chatbot.feedback.hintOptional' | transloco)"
                              [ngClass]="pipMode ? 'feedback-text pip' : 'feedback-text'" [(ngModel)]="message.feedbackText"></sh-input-text>
                            }
                            @if (message.feedbackType && !message.feedbackSubmitted && message.feedbackType==='dislike') {
                              <sh-button id="chatbot-button-33"
                                [disabled]="!message.feedbackType || (message.isMandatory && (message.feedbackText?.length || 0) < 10) || isFeedbackLoading"
                                [attr.label]="'chatbot.feedback.submit' | transloco" color="primary" (click)="submitFeedback($event, message)"
                              [style.width]="'110px'"></sh-button>
                            }
                            @if (isFeedbackLoading) {
                              <sh-spinner id="chatbot-spinner-34" size="s"></sh-spinner>
                            }
                            @if (!isFeedbackLoading && !isFeedbackError && message.feedbackSubmitted) {
                              <sh-text id="chatbot-text-35" style="color:#279B44; font-weight: bold; text-align: right;"
                              >{{ 'chatbot.feedback.thankYou' | transloco }}</sh-text>
                            }
                            @if (message.feedbackSubmitted && isFeedbackError) {
                              <sh-text id="chatbot-text-36" style="color:#E53633; font-weight: bold; text-align: right;"
                              >{{ 'chatbot.feedback.error' | transloco }}</sh-text>
                            }
                          </div>
                        }
                      </sh-box-section>
                    </sh-box>
                  </div>
                  <!-- Suggestions -->
                  @if (message.suggestions?.length > 0 && suggestionsEnabled && !message.iStreaming) {
                    <div
                      style="max-width: 70%; padding-top: 16px; position: relative; left: 50px; display: flex; gap: 8px; flex-wrap: wrap;">
                      @for (suggestion of message.suggestions; track suggestion) {
                        <div style="width: 100%">
                          <sh-button color="tertiary" [label]='suggestion'
                            [disabled]="displayedMessages[i + 1]?.isOptionAnswer" size="full-width"
                            [id]="'suggestion-button-'+i+suggestion"
                            (click)="sendMessage($event, 'option', suggestion, message.from === 'bot-like' ? suggestion : undefined, true)">
                          </sh-button>
                          <sh-tooltip id="chatbot-tooltip-tooltip" [label]="suggestion" [target]="'suggestion-button-'+i+suggestion"
                          placement="top" variation="short" delay></sh-tooltip>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- !Normal Search Bar-->
      @if (!initialViewActive && !pipMode) {
        <div #search
          style="width: 100%; display: flex; flex-direction: row; justify-content: center; gap: 12px; align-items: center;">
          <!-- We want to block the input when options are presented to us -->
          <app-chat-search #searchbar
            [disabled]="isStreaming || (displayedMessages && displayedMessages[displayedMessages?.length - 1]?.options?.length > 0)"
            [streaming]="isStreaming"
            (search)="sendMessage($event, 'chat', undefined, undefined, shouldMarkPromptAsOptionAnswer() ? true : undefined)" [label]="'chatbot.search.placeholder' | transloco"
            (interrupt)="interruptStreaming()"
            [style.width]="!pipMode ? defineChatSize(screen.size,'conversation') : '100%'"
            [style.padding-left]="defineChatPadding(screen.size)"
            [style.padding-right]="defineChatPadding(screen.size)">
            <sh-icon #aiicon size="xs" (click)="openAI()" id="ai-tip" icon="panel" button></sh-icon>
            @if (displayedMessages.length > 0) {
              <sh-icon #versionicon size="xs" (click)="openVersion()" id="version-tip" icon="information"
              button></sh-icon>
            }
          </app-chat-search>
        </div>
      }
      @if (!initialViewActive && pipMode) {
        <div #search
          style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; gap: 12px; align-items: center;">
          <sh-icon #aiiconPip size="xs" style="margin: 0 4px" (click)="openAIPip()" id="ai-tip-pip" icon="panel" button></sh-icon>
          <app-chat-search #searchbar [pipMode]="true"
            [disabled]="isStreaming || (displayedMessages && displayedMessages[displayedMessages?.length - 1]?.options?.length > 0)"
            [streaming]="isStreaming"
            (search)="sendMessage($event, 'chat', undefined, undefined, shouldMarkPromptAsOptionAnswer() ? true : undefined)" [label]="'chatbot.search.placeholder' | transloco"
            (interrupt)="interruptStreaming()"
            [style.width]="!pipMode ? defineChatSize(screen.size,'conversation') : '100%'"
            >
          </app-chat-search>
        </div>
      }
      <!-- <sh-popover id="chatbot-popover-pip-1"  #aimenu sticky passive position="top" target="ai-tip-pip" overlay-target-distance="1"
      viewport-padding="0.5" style="width:300px; height: 150px ; " [visible]="aiOpen && pipMode" (overlay-closed)="aiClosed()">
      <sh-text id="chatbot-text-41" size="title-1">{{ 'chatbot.ai.configureTitle' | transloco }}</sh-text>
      <sh-text id="chatbot-text-42" size="body-1">{{ 'chatbot.ai.configureDescription' | transloco }}</sh-text>
      <app-chat-toggle [(checked)]="suggestionsEnabled" (checkedChange)="onToggleChanged($event)"
        [ariaLabel]="'chatbot.ai.suggestionsToggle' | transloco">
        {{ 'chatbot.ai.suggestionsToggle' | transloco }}
      </app-chat-toggle>
    </sh-popover> -->
  </sh-box-section>
}

</sh-box>

<sh-popover id="chatbot-popover-38" #versionmenu sticky passive position="top" target="version-tip" overlay-target-distance="1"
  viewport-padding="0.5" style="width:300px ; z-index: 500" [visible]="versionOpen"
  (overlay-closed)="versionClosed()">
  <sh-text id="chatbot-text-39" [innerHTML]="displayedMessages[displayedMessages.length - 1]?.botInformation | markdown"></sh-text>
</sh-popover>

<sh-popover id="chatbot-popover-40" #aimenu sticky passive position="top" target="ai-tip" overlay-target-distance="1"
  viewport-padding="0.5" style="width:300px ;" [visible]="aiOpen && !pipMode" (overlay-closed)="aiClosed()">
  <sh-text id="chatbot-text-41" size="title-1">{{ 'chatbot.ai.configureTitle' | transloco }}</sh-text>
  <sh-text id="chatbot-text-42" size="body-1">{{ 'chatbot.ai.configureDescription' | transloco }}</sh-text>
  <app-chat-toggle [(checked)]="suggestionsEnabled" (checkedChange)="onToggleChanged($event)"
    [ariaLabel]="'chatbot.ai.suggestionsToggle' | transloco">
    {{ 'chatbot.ai.suggestionsToggle' | transloco }}
  </app-chat-toggle>
</sh-popover>
@if (imagePreviewVisible) {
  <div class="image-preview-overlay" (click)="closeImagePreview()">
    <button class="image-preview-close" type="button" [attr.aria-label]="'chatbot.image.closeAriaLabel' | transloco"
    (click)="closeImagePreview(); $event.stopPropagation()">{{ 'chatbot.image.closeButton' | transloco }}</button>
    <img [src]="previewImageSrc" [attr.alt]="'chatbot.image.expandedAlt' | transloco" (click)="$event.stopPropagation()" />
  </div>
}

<!-- <app-info-modal></app-info-modal> -->